import { useEffect } from 'react';
import schoolService from '../../services/api/schoolService';

// Debounced school duplicate check, mirroring GroupDuplicateWatch. `excludeId` lets the
// edit surface exclude the school being edited from its own check (URN is locked on edit,
// so the check keys on the name). `active` lets a host pause it (e.g. while editing an
// existing row). A last-wins latch stops a slow, superseded response from clobbering a
// newer result.
export default function SchoolDuplicateWatch({ name, urn, excludeId, active = true, onResult }) {
  useEffect(() => {
    if (!active) return undefined;
    const n = (name || '').trim();
    const u = (urn || '').toString().trim();
    if (!n && !u) {
      onResult(null);
      return undefined;
    }
    let current = true;
    const timer = setTimeout(() => {
      schoolService.checkSchoolDuplicate(n, u, excludeId).then((result) => {
        if (current) onResult(result && result.isDuplicate ? result : null);
      });
    }, 500);
    return () => {
      current = false;
      clearTimeout(timer);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [name, urn, excludeId, active]);
  return null;
}
